import { useTranslation } from "react-i18next";
import { ArrowsLeftRight, Check } from "@phosphor-icons/react";
import {
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from "@hulahoop/ui";
import type { UserOrganization } from "@/domain/organization";
import { ShellOrganizationMark } from "./ShellOrganizationMark";

interface ShellOrganizationSwitchProps {
  organizations: UserOrganization[];
  selectedUuid: string | null;
  onSwitch: (uuid: string) => void;
}

export function ShellOrganizationSwitch({
  organizations,
  selectedUuid,
  onSwitch,
}: ShellOrganizationSwitchProps) {
  const { t } = useTranslation();
  return (
    <>
      <DropdownMenuSeparator />
      <DropdownMenuSub>
        <DropdownMenuSubTrigger className="font-medium">
          <ArrowsLeftRight /> {t("nav.switch_organization")}
        </DropdownMenuSubTrigger>
        <DropdownMenuSubContent>
          {organizations.map(({ organization }) => (
            <DropdownMenuItem
              key={organization.uuid}
              className="font-medium"
              disabled={!organization.is_active || organization.uuid === selectedUuid}
              onClick={() => onSwitch(organization.uuid)}
            >
              <ShellOrganizationMark
                name={organization.name}
                logoUrl={organization.logo_signed_url}
                size="sm"
              />
              {organization.name}
              {organization.uuid === selectedUuid && <Check aria-hidden className="ml-auto" />}
            </DropdownMenuItem>
          ))}
        </DropdownMenuSubContent>
      </DropdownMenuSub>
    </>
  );
}
